<div class="row ms-2 ps-0 pe-0 ms-md-0 ms-md-0 ps-md-0">
  <div class="col-12 ps-md-0">
    <h5>{{localize(langSection.RequestFormPage, langText.EmptyTrailer)}} ({{localize(langSection.TrailerCard, langText.ToUPS)}})</h5>
    <div class="row align-items-baseline mb-3">
      <div class="col-11 col-md-6 col-lg-auto">
        <div class="request-input-short">
          <label class="fw-bold display-block mb-0">{{localize(langSection.RequestFormPage, langText.TrailerType)}} *</label>
          <ups-select class="{{errors.trailerType ? 'error' : ''}}" [readonly]="isDisabled('trailerType')" [value]="model.trailerType" [list]="trailerTypes" (change)="onFieldChange('trailerType', $event.target.value)"></ups-select>
          @if (errors.trailerType) {
<span class="text-danger">{{errors.trailerType}}</span>
}
        </div>
      </div>

      <div class="col-11 col-md-6 col-lg-auto">
        <div class="request-input-short">
          <label class="fw-bold display-block mb-0">{{localize(langSection.RequestFormPage, langText.TrailerNumber)}}</label>
          <input type="text" mask="AAAAAAAAAAAA" class="form-control {{errors.trailerNumber ? 'error' : ''}}" [ngModel]="model.trailerNumber" [readonly]="isDisabled('trailerNumber')" (input)="onFieldChange('trailerNumber', $event.target.value)" />
          @if (errors.trailerNumber) {
<span class="text-danger">{{errors.trailerNumber}}</span>
}
        </div>
      </div>
    </div>

    <div class="row align-items-baseline">
      <div class="col-11 col-md-6 col-lg-auto">
        <div class="request-input-short mb-3">
          <label class="fw-bold display-block mb-0">{{localize(langSection.RequestFormPage, langText.Bay)}}</label>
          <input type="text" class="form-control {{errors.bayNumber ? 'error' : ''}}" [ngModel]="model.bayNumber" [readonly]="isDisabled('bayNumber')" mask="AAAA" (input)="onFieldChange('bayNumber', $event.target.value)" />
          @if (errors.bayNumber) {
<span class="text-danger">{{errors.bayNumber}}</span>
}
        </div>
      </div>
    </div>
  </div>
</div>

<div class="row ms-2 ps-0 pe-0 ms-md-0 ms-md-0 ps-md-0 mt-3">
  <div class="col-12 ps-md-0">
    <h5>{{localize(langSection.RequestFormPage, langText.AdditionalInformation)}}</h5>
    <div class="row mb-3">
      <div class="col-11 col-lg-auto">
        <div class="request-input-long">
          <label class="fw-bold display-block mb-0">{{localize(langSection.RequestFormPage, langText.RequestReason)}} {{isNewRequest ? '*' : ''}}</label>
          <span class="request-reason-text {{errors.requestReason ? 'error' : ''}}">
            <textarea class="form-control" [ngModel]="model.requestReason" [readonly]="isDisabled('requestReason')" maxlength="256" (input)="onFieldChange('requestReason', $event.target.value)"></textarea>
          </span>
          @if (errors.requestReason) {
<span class="text-danger">{{errors.requestReason}}</span>
}
        </div>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-11 col-md-6 col-lg-auto">
        <div class="request-input-short">
          <label class="fw-bold display-block mb-0">{{localize(langSection.RequestFormPage, langText.PickupNumber)}}</label>
          <input type="text" class="form-control {{errors.pickUpNumber ? 'error' : ''}}" [ngModel]="model.pickUpNumber" [readonly]="isDisabled('pickUpNumber')" maxlength="30" (input)="onFieldChange('pickUpNumber', $event.target.value)" />
          @if (errors.pickUpNumber) {
<span class="text-danger">{{errors.pickUpNumber}}</span>
}
        </div>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-11 col-lg-auto">
        <div class="request-input-long">
          <label class="fw-bold display-block mb-0">{{localize(langSection.RequestFormPage, langText.SpecialInstructions)}}</label>
          <textarea class="form-control {{errors.specialInstructions ? 'error' : ''}}" [ngModel]="model.specialInstructions" [readonly]="isDisabled('specialInstructions')" maxlength="256" (input)="onFieldChange('specialInstructions', $event.target.value)"></textarea>
          @if (errors.specialInstructions) {
<span class="text-danger">{{errors.specialInstructions}}</span>
}
        </div>
      </div>
    </div>
  </div>
</div>
